export const URL_PARAM_CUSTOMER_ID = 'customerId'
export const URL_PARAM_START_DATE = 'sInvoiceDate'
export const URL_PARAM_END_DATE = 'eInvoiceDate'
export const URL_PARAM_STATUS = 'status'
export const URL_PARAM_LATEST_INVOICE_ONLY = 'latestInvoiceOnly'
